import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import { Link } from 'react-router-dom';
import { KC_COLORS } from '../theme';
import { KC_TRUNCATE, truncateAtWord } from '../truncateAtWord';

function ResultIcon({ type }) {
  const Icon =
    type === 'category'
      ? CategoryOutlinedIcon
      : type === 'dictionary'
        ? MenuBookOutlinedIcon
        : type === 'tool'
          ? CalculateOutlinedIcon
          : type === 'navigator'
            ? ExploreOutlinedIcon
            : DescriptionOutlinedIcon;

  return (
    <span
      className="inline-flex shrink-0 items-center justify-center w-12 h-12 md:w-[52px] md:h-[52px] rounded-xl"
      style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
    >
      <Icon sx={{ fontSize: { xs: 24, md: 26 } }} />
    </span>
  );
}

export function SearchResultRow({ result }) {
  return (
    <Link
      to={result.path}
      className="kc-search-result group flex items-start gap-4 md:gap-5 px-5 md:px-7 py-5 md:py-6 border-b last:border-b-0 transition-colors duration-200"
      style={{ borderColor: KC_COLORS.border }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = KC_COLORS.lightGrey;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
    >
      <ResultIcon type={result.type} />

      <div className="min-w-0 flex-1 text-left">
        <div className="flex flex-wrap items-center gap-2">
          <h3
            className="kc-type-h3 m-0 group-hover:opacity-90 transition-opacity"
            style={{ color: KC_COLORS.primaryNavy }}
          >
            {result.title}
          </h3>
          {result.type === 'dictionary' ? (
            <span
              className="inline-flex items-center rounded-md px-2 py-0.5 kc-type-caption font-bold uppercase tracking-wide"
              style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
            >
              Dictionary
            </span>
          ) : null}
          {result.type === 'navigator' ? (
            <span
              className="inline-flex items-center rounded-md px-2 py-0.5 kc-type-caption font-bold uppercase tracking-wide"
              style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
            >
              Navigator
            </span>
          ) : null}
          {result.type === 'tool' ? (
            <span
              className="inline-flex items-center rounded-md px-2 py-0.5 kc-type-caption font-bold uppercase tracking-wide"
              style={{ backgroundColor: KC_COLORS.tealLight, color: KC_COLORS.teal }}
            >
              Tool
            </span>
          ) : null}
        </div>
        <p className="mt-2 kc-type-body" style={{ color: KC_COLORS.navy700 }}>
          {result.breadcrumb}
        </p>
        {result.summary ? (
          <p
            className="mt-2 kc-type-caption kc-listing-summary"
            style={{ color: KC_COLORS.gray600 }}
          >
            {truncateAtWord(result.summary, KC_TRUNCATE.twoLines)}
          </p>
        ) : null}
        {(result.type === 'article' || result.type === 'dictionary') &&
        result.readTime ? (
          <p className="mt-2 kc-type-caption" style={{ color: KC_COLORS.gray600 }}>
            {result.readTime}
          </p>
        ) : null}
      </div>
    </Link>
  );
}
